import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { showErrorMessage } from 'actions/messages';
import { getCurrentUser } from 'selectors/authentication';

class BaseMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    this.props.dispatch(
      showErrorMessage(
        'Something went wrong with the request, please try again later.'
      )
    );
  }

  render() {
    if (this.state.hasError) {
      return <Redirect to="/" />;
    } else {
      return <div>{this.props.children}</div>;
    }
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
  };
})(BaseMenuContainer);



// WEBPACK FOOTER //
// ./src/components/shared/BaseMenuContainer.js